// Numer inwentarzowy zajęty przez sprzęt nieaktywny (24.10.2026). Serwer odpowiada wtedy 409
// `inventory_number_inactive_holder` (Login/backend/lib/numerPoNieaktywnym.js), a formularz pyta,
// czy przenieść numer, i po zgodzie wysyła zapis ponownie z `take_over_inventory_number: true`.

export const czyNumerNieaktywnego = (err) => err?.response?.status === 409
  && err.response.data?.code === 'inventory_number_inactive_holder';

/** Opcje okna potwierdzenia (components/ui/Modal.js#useConfirm). */
export function pytanieOPrzeniesienie(t, data) {
  const holders = Array.isArray(data?.holders) ? data.holders : [];
  const jeden = holders.length <= 1;
  const h = holders[0] || {};
  return {
    title: jeden ? t('equipmentNumber.moveTitle') : t('equipmentNumber.moveTitleMany'),
    message: jeden
      ? t('equipmentNumber.moveOne').replace('{number}', h.inventory_number || '').replace('{name}', h.name || '')
      : t('equipmentNumber.moveMany').replace('{numbers}', holders.map((x) => x.inventory_number).join(', ')),
    confirmLabel: jeden ? t('equipmentNumber.moveConfirm') : t('equipmentNumber.moveConfirmMany'),
    cancelLabel: t('equipmentNumber.moveCancel'),
    tone: 'primary',
  };
}

/**
 * Zapis z obsługą przeniesienia: `zapisz(dodatkowe)` wysyła żądanie. Przy numerze nieaktywnej
 * sztuki pyta i ponawia z flagą; odmowa oddaje pierwotny błąd (formularz pokaże komunikat serwera).
 */
export async function zapiszZPrzeniesieniemNumeru(zapisz, { confirm, t }) {
  try {
    return await zapisz({});
  } catch (err) {
    if (!czyNumerNieaktywnego(err)) throw err;
    const ok = await confirm(pytanieOPrzeniesienie(t, err.response.data));
    if (!ok) throw err;
    return zapisz({ take_over_inventory_number: true });
  }
}
